/**
 * A tiny in-page bus of things that happen in response to the user: requests the fetch
 * patch saw start (services/netCapture.js) and console errors the console wrapper saw
 * (services/consoleCapture.js). The friction capture (services/frictionCapture.js)
 * listens, to tell a click that did something from a dead one and to spot an error
 * click. Carries only a kind, never a URL or a message.
 */

/** @typedef {"request" | "error"} ActivityKind */

const listeners = new Set();

/** Tell every listener that `kind` happened; a throwing listener is ignored. */
export function noteActivity(kind) {
  for (const fn of listeners) {
    try {
      fn(kind);
    } catch {
      /* telemetry is best-effort */
    }
  }
}

/** Listen for activity; returns the unsubscribe function. */
export function onActivity(fn) {
  listeners.add(fn);
  return () => {
    listeners.delete(fn);
  };
}
